import styled from "styled-components";
export const SuccessIconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  
  & .MuiSvgIcon-root {
    font-size: 48px !important;
    color: ${props => props.successIconColor || '#2e7e33'};
  }
`;

export const UploadIconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  
  & .MuiSvgIcon-root {
    font-size: 48px !important;
    color: ${props => props.uploadIconColor || '#1976D2'};
  }
`;

export const FileName = styled.p`
  margin: 8px 0 4px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
`;

export const UploadText = styled.p`
  margin: 8px 0 4px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
`;

export const FormatText = styled.p`
  margin: 0;
  font-size: 12px;
  color: #999;
`;


export const StyledFileInput = styled.div`
  .RaFileInput-dropZone {
    border: 2px dashed ${props => props.isValid ? "#4CAF50" : "#BDBDBD"};
    border-radius: 8px;
    padding: 16px 20px !important;
    text-align: center;
    background-color: ${props => props.isValid ? "#F1F8F4" : "#FAFAFA"};
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: ${props => props.isValid ? "#4CAF50" : "#1976D2"};
      background-color: ${props => props.isValid ? "#E8F5E9" : "#F5F5F5"};
    }
    
    .MuiSvgIcon-root {
      color: ${props => props.isValid ? "#4CAF50" : "#1976D2"};
      font-size: 36px !important;
      margin-bottom: 8px !important;
    }
    
    p {
      font-size: 14px;
      color: #666;
      margin: 8px 0;
      
      &:first-of-type {
        font-weight: 500;
        color: #333;
      }
      
      &:last-of-type {
        font-size: 12px;
        color: #999;
      }
    }
  }
  
  .RaFileInput-removeButton {
    margin-top: 12px;
  }
`;
